export enum EventTypes {
  PAGE_VIEW = 'Page View',
  LAND_ON_SIGNUP = 'land-on-signup',
  SIGNUP_COMPLETED = 'signup-completed',
  EMAIL_VERIFIED = 'email-verified',
  FIRST_TIME_USER_LOGIN = 'first-time-user-login',
  LOGIN_SUCCESS = 'login-success',
  LOGOUT = 'logout',

  // Integrations / linked accounts
  INTEGRATION_CONNECT_STARTED = 'integration-connect-started',

  // Transactions
  CSV_UPLOAD_STARTED = 'csv-upload-started',
  CSV_UPLOAD_COMPLETED = 'csv-upload-completed',

  // Reports
  SALES_REPORT_VIEWED = 'sales-report-viewed',
  SALES_REPORT_DOWNLOADED = 'sales-report-downloaded',

  // Nexus
  NEXUS_STATE_ADDED = 'nexus-state-added',
  NEXUS_COUNTRY_ADDED = 'nexus-country-added',

  // Billing / subscription
  PLAN_CHECKOUT_STARTED = 'plan-checkout-started',
  PLAN_SUBSCRIBED = 'plan-subscribed',
  PLAN_UPGRADE_STARTED = 'plan-upgrade-started',

  // Auto-filing
  AUTOFILING_ENROLLMENT_STARTED = 'autofiling-enrollment-started',
  AUTOFILING_ENROLLMENT_SUBMITTED = 'autofiling-enrollment-submitted',
  AUTOFILING_PAYMENT_STARTED = 'autofiling-payment-started',

  // Auto-register
  AUTOREGISTER_STARTED = 'autoregister-started',
  AUTOREGISTER_SUBMITTED = 'autoregister-submitted',
  AUTOREGISTER_PAYMENT_STARTED = 'autoregister-payment-started',
}
